import React from 'react';
import { useState } from 'react';

import { Card, Modal, message } from 'antd';

import Configurazione from '../../../Configurazione';
import sessionManager, { eVariableType } from '../../../SessionManager';
import { GetFormattedData } from '../../../Utility';
import api from '../../../api';
import stringres from '../../../translations/stringres';
import MenuAddEdit from '../../Common/MenuAddEdit';
import EventoClienteAddEdit from './EventoClienteAddEdit';
import './eventi.css';

export default function EventoCliente({ item, reload }) {
    const configurazione = Configurazione();
    const [selectedEvento, setSelectedEvento] = useState(null);
    const [openAddEdit, setOpenAddEdit] = useState(false);

    function checkDataScadenza(item) {
        const dscad = new Date(item.dataScadenza).getTime();

        if (dscad === 0) return false;
        else return true;
    }

    function titolo(itm) {
        return (
            <div className="container">
                <div className="left-div">
                    <span>{itm.descrizioneTipo}</span>
                    <span className="card-title">
                        {' '}
                        <GetFormattedData data={itm.dataCreazione}></GetFormattedData>
                    </span>
                </div>
                <div className="right-div">
                    <MenuAddEdit
                        onModifica={onModificaEvento}
                        onCancella={onCancellaEvento}
                        onSelectRow={() => onSelectRow(itm)}
                    ></MenuAddEdit>
                    {/* <Dropdown trigger={['click']} menu={{ items, }} placement="topLeft" arrow onClick={() => setSelectedEvento(item)}>
                        <Button icon={<DashOutlined />}></Button>
                    </Dropdown> */}
                </div>
            </div>
        );
    }

    function onSelectRow(it) {
        setSelectedEvento(it);
    }

    function onModificaEvento(e) {
        try {
            setOpenAddEdit(true);
        } catch (error) {
            message.error(error.message);
        }
    }
    async function onCancellaEvento(e) {
        try {
            const result = await api.delete(
                'CRM/Clienti/EventiCliente/Delete?' +
                    'idSocieta=' +
                    sessionManager.get(eVariableType.IDSocieta) +
                    '&idEvento=' +
                    selectedEvento.idEvento
            );
            if (result != null && result.data != null) {
                message.success(stringres.t('successo'));
                reload();
            } else {
                message.error(result.statusText);
            }
        } catch (error) {
            message.error(error.message);
        }
    }

    async function conferma(e) {
        if (e) reload();

        setOpenAddEdit(false);
    }

    return (
        <div>
            <Card size="small" title={titolo(item)}>
                {checkDataScadenza(item) ? (
                    <span>
                        Data Scadenza: <GetFormattedData data={item.dataScadenza}></GetFormattedData>
                    </span>
                ) : null}
                <br></br>
                {item.descrizioneEvento}
            </Card>
            <Modal
                title={stringres.t('eventoaddedit')}
                open={openAddEdit}
                onCancel={() => setOpenAddEdit(false)}
                footer={null}
            >
                <EventoClienteAddEdit
                    evento={item}
                    codCliente={item.codCliente}
                    confirm={conferma}
                ></EventoClienteAddEdit>
            </Modal>
        </div>
    );
}
